export default class AbTestBuckets {
  static ON = 'on';
  static OFF = 'off';
  static CA_OFF = 'california_off';
  static CONTROL = 'control';
  static EXCLUDED = 'excluded';
}

export class NavRedesignAbTestBuckets {
  static CONTROL = AbTestBuckets.CONTROL;
  static MENU_NAV = 'menu_nav';
  static SIMPLE_NAV = 'simple_nav';
}

export class RecentlyMovedPricingFlowAbTestBuckets {
  static CONTROL = AbTestBuckets.CONTROL;
  static PROMPT_WITH_RECENT_ADDRESS ='prompt_with_recent_address';
}

export class WebTextToDownloadAbTestBuckets {
  static PROMPT_FOR_SMS = 'prompt_for_sms';
  static SEND_SMS_IMMEDIATELY = 'send_sms_immediately';
}

export class AgentBannerBuckets {
  static CONTROL = 'control';
  static WITH_MODAL = 'with_modal';
  static WITHOUT_MODAL = 'without_modal';
}

export class RootAgentBuckets {
  static CONTROL = 'control';
  static CS_REP = 'cs_rep';
  static LICENSED_AGENT = 'licensed_agent';
}

export class StashLandingPageBuckets {
  static CONTROL = 'control';
  static VALUE = 'value';
  static SOCIAL_PROOF = 'social_proof';
  static TECH = 'tech'
}

export class AgentsInQuoteFlowBuckets {
  static CONTROL = 'control';
  static NEW_ICON_MODAL = 'new_icon_with_modal';
  static OLD_ICON_MODAL = 'old_icon_with_modal';
  static NEW_ICON_NO_MODAL = 'new_icon_without_modal';
}

export class RootAgentPrefillProfileBuckets {
  static CONTROL = 'control';
  static CS_REP = 'cs_rep';
  static LICENSED_AGENT = 'licensed_agent';
}
